var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotchedBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 935.918,
    height: 17.491,
    viewBox: "0 0 935.918 17.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_8_1",
    "data-name": "Component 8 \\u2013 1",
    transform: "translate(0 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M493.082,4141.977H687l16.328,14,15.758-14H1429",
    transform: "translate(-493.082 -4141.977)",
    fill: "none",
    stroke: "#d0e8ed",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotchedBorder);
export default __webpack_public_path__ + "static/media/notched-border.6c398bd09c558970637ade56d7831f7d.svg";
export { ForwardRef as ReactComponent };